/**
 * usePageTitle — set document.title per halaman
 * Usage: usePageTitle('Kamar Kami') → "Kamar Kami – Ndalem Mataram"
 */
import { useEffect } from 'react';

const SITE = 'Ndalem Mataram';

export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} – ${SITE}` : `${SITE} – Homestay Budaya Jawa Banyuwangi`;
    return () => { document.title = `${SITE} – Homestay Budaya Jawa Banyuwangi`; };
  }, [title]);
}
